import { useState } from 'react';
import { filesApi } from '../../../api/files.api';
import toast from 'react-hot-toast';
import { downloadService } from '@/services/download/download.service';
import { useTour } from '@reactour/tour';
import { downloadMockCsvFile } from '@/utils/downloadMockCsvFile';

export const useFilesDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const { isOpen, setCurrentStep } = useTour(); // mode tutoriel actif si isOpen

  const downloadCsv = async () => {
    setIsDownloading(true);
    try {
      if (isOpen) {
        downloadMockCsvFile();
        await new Promise((resolve) => setTimeout(resolve, 1000));
        setCurrentStep(6);
      } else {
        const { blob, filename } = await filesApi.downloadCsv();
        downloadService.downloadBlob(blob, filename);
      }
    } catch {
      toast.error('Erreur lors du téléchargement du CSV, veuillez réessayer.');
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    downloadCsv,
    isDownloading,
  };
};

export const useFilesMockDownload = () => {
  const [isMockDownloading, setIsDownloading] = useState(false);

  const downloadMockCsv = () => {
    setIsDownloading(true);
    try {
      downloadMockCsvFile();
    } catch {
      toast.error('Erreur lors du téléchargement du CSV, veuillez réessayer.');
    } finally {
      setIsDownloading(false);
    }
  };

  return {
    downloadMockCsv,
    isMockDownloading,
  };
};
